export default function isMobileSize() {
    return window.innerWidth < 768;
}